<script>
  const logos = [
    {src: 'aa.png',                 scale: 1},
    {src: 'aeromexico.svg',         scale: 1},
    {src: 'airwis.png',             scale: 0.9},
    {src: 'alaska.png',             scale: 1},
    {src: 'allegiant_air.jpg',      scale: 1},
    {src: 'atlas.png',              scale: 1},
    {src: 'aviall.jpg',             scale: 0.9},
    {src: 'boeing.png',             scale: 1},
    {src: 'british.png',            scale: 1},
    {src: 'delta.png',              scale: 1},
    {src: 'embraer.png',            scale: 1},
    {src: 'envoy.png',              scale: 0.9},
    {src: 'expressjet.png',         scale: 1},
    {src: 'gulfstream.png',         scale: 1},
    {src: 'jetblue.png',            scale: 1},
    {src: 'kellstrom-defense.jpg',  scale: 1.2},
    {src: 'liebherr.svg',           scale: 0.8},
    {src: 'lockheed-martin.svg',    scale: 1.5},
    {src: 'northern-air-cargo.jpg', scale: 1},
    {src: 'parker.png',             scale: 1},
    {src: 'southwest.png',          scale: 1},
    {src: 'tsa.png',                scale: 1},
    {src: 'turkish-airlines.jpg',   scale: 1.2},
    {src: 'uac.jpg',                scale: 1},
    {src: 'unical_logo.jpg',        scale: 1},
    {src: 'united.png',             scale: 1},
  ]
</script>

<div class="belly-band">
  <div class="panel">
    {#each logos as logo}
      <img src={`/customer-logos/${logo.src}`} alt="Logo" style="height: {parseInt(30 * logo.scale)}px; margin-top: {parseInt(-10 * logo.scale + 20)}px;">
    {/each}
    {#each logos as logo}
      <img src={`/customer-logos/${logo.src}`} alt="Logo" style="height: {parseInt(30 * logo.scale)}px; margin-top: {parseInt(-10 * logo.scale + 20)}px;">
    {/each}
  </div>
</div>

<style>
.belly-band {
  height: 120px;
  width: 100%;
  margin: 0 auto;
  position: relative;
  overflow: hidden;
  transform: translate3d(0, 0, 0);
}
.belly-band .panel {
  display: flex;
  opacity: .3;
  padding: 30px 0 40px;
  transform: translate3d(0, 0, 0);
  position: absolute;
  left: 20px;
  top: 0;
  /*height: 100%;
  width: 300%;*/
  overflow: hidden;
  animation: moveBellyBand 40s linear infinite;
}
@keyframes moveBellyBand {
  100% {
    transform: translateX(-50%);
  }
}
img{
  flex: 0 1;
  height: 30px;
  margin: 0 20px;
}
</style>
